/**
 * Raw OCPP frame log (Phase A.1).
 */

import { enc, ocppRequest } from './ocppApi';
import type { GetOcppLogQuery, GetOcppLogResponse } from '../models';

export const fetchOcppLog = (chargerId: string, q: GetOcppLogQuery = {}) =>
  ocppRequest<GetOcppLogResponse>({
    method: 'GET',
    path: `log/${enc(chargerId)}`,
    query: {
      direction: q.direction,
      action: q.action,
      since: q.since,
      until: q.until,
      limit: q.limit,
      offset: q.offset,
    },
  });
